import React from "react";
import LottieAnimation from "../lottie-animation";
import "./index.css";

const EmptyState = ({
  title = "No Data Available",
  message = "There is no data to display at the moment.",
  image = null,
  className = "",
  imageClassName = "",
  style = {},
}) => {
  return (
    <div className={`empty-state ${className}`} style={style}>
      <div className="empty-state-content">
        <LottieAnimation
          animation={LottieAnimation}
          loop={false}
          autoplay={true}
          className="empty-state-animation"
          style={{ width: "100%", height: "100%" }}
        />
        {image && <img src={image} alt="Relax" className={`empty-state-image ${imageClassName}`} />}
        <div className="empty-state-text">
          <h3 className="empty-state-title">{title}</h3>
          <p className="empty-state-message">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
